  "use client"

  import * as React from "react"

  import { Navigate } from "react-router-dom"
  import { useAuth } from "../contexts/AuthContext"
  import { LoadingSpinner } from "./LoadingSpinner"

  interface ProtectedRouteProps {
    children: React.ReactNode
  }

  export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { user, isLoading } = useAuth()

    if (isLoading) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <LoadingSpinner />
        </div>
      )
    }

    if (!user) {
      return <Navigate to="/login" replace />
    }

    return <>{children}</>
  }
